import {
  ArrowRightLeft,
  Boxes,
  ClipboardCheck,
  Compass,
  Laptop,
  Map,
  PackageCheck,
  Recycle,
  RefreshCw,
  Rocket,
  Settings,
  ShieldCheck,
  ShoppingCart,
  Target,
} from "lucide-react";

export const SERVICE_ICONS = {
  ArrowRightLeft,
  Boxes,
  ClipboardCheck,
  Compass,
  Laptop,
  Map,
  PackageCheck,
  Recycle,
  RefreshCw,
  Rocket,
  Settings,
  ShieldCheck,
  ShoppingCart,
  Target,
};

export const SERVICE_ICON_NAMES = Object.keys(SERVICE_ICONS);

const ServiceIcon = ({ name, className = "" }) => {
  const Glyph = SERVICE_ICONS[name] || Boxes;
  return (
    <Glyph
      className={className}
      size="100%"
      strokeWidth={1.4}
      aria-hidden="true"
    />
  );
};

export default ServiceIcon;
